/**
 * URL-hash keys for the users feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#assign-role/5`).
 */
export const USERS_HASH = {
  /** `#import` — UsersImportDialog (bulk import from Excel). */
  import: 'import',
  /** `#assign-role/<userId>` — assign a role to a specific user. */
  assignRole: 'assign-role',
  /** `#remove-role/<userId>/<roleName>` — remove a role from a specific user. */
  removeRole: 'remove-role',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type UsersHashKey = (typeof USERS_HASH)[keyof typeof USERS_HASH];
